import axios from "axios";

class UserService {

    static BASE_URL = "https://sprintbe.globsolutions.in";
    //static BASE_URL = "http://localhost:8080";


  static async login(email, password) {
    try {
      const response = await axios.post(`${UserService.BASE_URL}/auth/login`, {
        email,
        password,
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async registerAdmin(userData) {
    try {
      const response = await axios.post(
        `${UserService.BASE_URL}/auth/register`,
        userData
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async registerEmployee(userData) {
    try {
      const response = await axios.post(
        `${UserService.BASE_URL}/auth/register/employee`,
        userData
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("roleId");
    localStorage.removeItem("userName");
    localStorage.removeItem("email");
    localStorage.removeItem("id");
    localStorage.removeItem("ins");

    localStorage.clear();

    console.log("localStorage cleared:", localStorage);
  }

  static isAuthenticated() {
    if (typeof localStorage !== "undefined") {
      const token = localStorage.getItem("token");
      return !!token;
    } else {
      return false;
    }
  }
}

export default UserService;
